import { useContext, useEffect } from "react";
import TimelinePlayerContext from "../context/TimelinePlayerContext";
import getAbsoluteTimeFromRelativeTime from "../utils/getAbsoluteTimeFromRelativeTime";

export default function useSeekToRelativeTimeHandler() {
  const {
    seekToRelativePosition,
    setSeekToAbsolutePosition,
    timelineItemIndex,
    timelinePositions,
    setSeekToRelativePosition,
  } = useContext(TimelinePlayerContext);

  useEffect(() => {
    if (seekToRelativePosition == undefined) return;
    setSeekToAbsolutePosition(
      getAbsoluteTimeFromRelativeTime(
        seekToRelativePosition,
        timelineItemIndex,
        timelinePositions,
      ),
    );

    setSeekToRelativePosition(undefined);
  }, [seekToRelativePosition]);
}
